module.exports = __webpack_public_path__ + "media/4x3/xk-62bc9bcf.svg";